import { formatDate } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { BlockedSeatsService } from 'src/app/services/blocked-seats.service';
import { EventosService } from 'src/app/services/eventos.service';

// Vista de mapa de la pestaña de pedidos del evento. Muestra el mapa de butacas del
// evento (mismo `app-create-map` que "Ver mapa" en la pestaña de Lugar y aforo), de modo
// que al hacer hover sobre una butaca ocupada aparece la info del pedido al que pertenece.
@Component({
  selector: 'app-event-orders-map',
  templateUrl: './event-orders-map.component.html',
  styleUrls: ['./event-orders-map.component.scss']
})
export class EventOrdersMapComponent implements OnInit {

  @Input() idEvent!: any;

  loading: boolean = true;
  venue: any = null;
  map: any = null;
  useMapVenue: boolean = false;

  // Sesiones del evento (ordenadas por fecha) para el selector de sesión del mapa.
  sessionsList: any[] = [];
  selectedSession: any = null;

  // Asientos bloqueados/ocupados de la sesión seleccionada.
  blockedSeatsEvent: any[] = [];
  blockedSeats: any[] = [];
  loadingBlockedSeats: boolean = false;
  // Mientras se pinta el canvas del mapa (tras cargar los datos de la sesión).
  loadingMap: boolean = false;

  constructor(private eventService: EventosService, private blockedSeatsService: BlockedSeatsService) { }

  ngOnInit(): void {
    if (!this.idEvent) {
      this.loading = false;
      return;
    }
    this.eventService.getEventById(this.idEvent).subscribe({
      next: (res: any) => {
        const data = res?.data;
        this.venue = data?.space;
        this.map = data?.map_version;
        this.useMapVenue = !!data?.use_map;
        this.sessionsList = [...(data?.sessions || [])].sort((a: any, b: any) =>
          new Date(a.start_date).getTime() - new Date(b.start_date).getTime());

        // Solo tiene sentido cargar el mapa si el evento usa mapa de butacas.
        if (this.useMapVenue && this.map && this.venue) {
          this.loadingMap = true;
          this.loadBlockedSeats();
        } else {
          this.loading = false;
        }
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  loadBlockedSeats(): void {
    this.loadingBlockedSeats = true;
    this.blockedSeatsService.getBlockedSeatsByEvent(this.idEvent).subscribe({
      next: (val: any) => {
        this.blockedSeatsEvent = Array.isArray(val.data) ? val.data : (val.data?.blocked_seats ?? []);
        if (this.sessionsList.length > 0) {
          this.selectedSession = this.sessionsList[0].id;
        }
        this.updateBlockedSeatsForSelectedSession();
        this.loadingBlockedSeats = false;
        this.loading = false;
      },
      error: () => {
        this.loadingBlockedSeats = false;
        this.loading = false;
      }
    });
  }

  updateBlockedSeatsForSelectedSession(): void {
    const sessionBlocks = this.blockedSeatsEvent.filter((bs: any) => bs.id_session == this.selectedSession);
    const globalBlocks = this.blockedSeatsEvent.filter((bs: any) => bs.id_session == null);
    this.blockedSeats = [...sessionBlocks, ...globalBlocks];
  }

  changeSession(): void {
    this.loadingMap = true;
    this.updateBlockedSeatsForSelectedSession();
  }

  onMapLoadingChange(loading: boolean): void {
    this.loadingMap = loading;
  }

  getSessionDateString(session: any): string {
    if (!session?.start_date) {
      return 'Sesión sin fecha';
    }
    return formatDate(session.start_date, 'dd/MM/yyyy - HH:mm', 'es', '+0000') + 'h';
  }
}
